import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

const $openStore = atom(false)

const close = () => $openStore.set(false)
const open = () => $openStore.set(true)

const useOpen = () => useStore($openStore)

const isAddContactsModalOpen = () => $openStore.get()
export { close, isAddContactsModalOpen, open, $openStore as openStore, useOpen }
